import { api } from "./api";

/**
 * Lightweight fire-and-forget click logger for cross-sell + affiliate links.
 * Never blocks the outbound navigation — even if the API call fails the
 * user's click still completes via the anchor's default href.
 *
 * Usage:
 *   <a href={url} onClick={() => trackClick("annuity_review", {source_page: "toolkit_library"})}>...</a>
 */
export function trackClick(kind, opts = {}) {
    try {
        api.post("/wealth/track-click", {
            kind,
            source_page: opts.source_page || null,
            lead_id: opts.lead_id || null,
            deliverable_id: opts.deliverable_id || null,
        }).catch(() => {});
    } catch (_) { /* never throw — must not block navigation */ }
}

export const AUGUSTA_URL =
    "https://learn.augustapreciousmetals.com/company-checklist-1/?apmtrkr_cid=1696&aff_id=1073&apmtrkr_cph=844-628-4303";

/**
 * Resolves the annuity-review URL.
 *
 * IMPORTANT: While yourannuityreview.com is offline (awaiting Emergent
 * Support to fix multi-domain SSL routing), we ALWAYS return the relative
 * `/review` path. The wealth domain serves the same React Router /review
 * route, so this works seamlessly for visitors on getyourwealthreport.com.
 *
 * Do NOT read REACT_APP_ANNUITY_SITE_URL here — that variable is currently
 * set to the dead absolute URL in production env, which would override the
 * fix. Once the annuity domain is restored, re-introduce the env override.
 *
 * Always appends utm_source=wealth_report (+ optional utm_content=<leadId>)
 * for admin attribution.
 */
export function annuityReviewUrl({ leadId, path = "/review" } = {}) {
    const qp = new URLSearchParams({ utm_source: "wealth_report" });
    if (leadId) qp.set("utm_content", leadId);
    return `${path}?${qp.toString()}`;
}

export function wealthSiteUrl({ leadId } = {}) {
    const sameHost = typeof window !== "undefined" && window.location.hostname.includes("getyourwealthreport");
    const wealthSite = process.env.REACT_APP_WEALTH_SITE_URL || "https://getyourwealthreport.com";
    const base = sameHost ? "/wealth" : `${wealthSite}/wealth`;
    const qp = new URLSearchParams({ utm_source: "annuity_review" });
    if (leadId) qp.set("utm_content", leadId);
    return `${base}?${qp.toString()}`;
}
